import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { FeatureFlagEnum } from '../../shared/constants/feature-flag.constants';
import { FeatureFlagService } from '../../shared/types/feature-flag.service.interface';

@Injectable()
export class AdminManagementGuard implements CanActivate {
  constructor(
    private readonly featureFlagService: FeatureFlagService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.featureFlagService
      .isEnabled(FeatureFlagEnum.AdminPortalManagement, undefined)
      .pipe(
        catchError(() => of(false)),
        map((isFeatureEnabled) =>
          isFeatureEnabled
            ? true
            : this.router.createUrlTree(['/accounts/list']),
        ),
      );
  }
}
